import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";

import translationEng from "./locale/en/en.json";
import translationHin from "./locale/hin/hin.json";

i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    detection: { order: ['querystring']},
    debug: true,
    // lng: "en",
    fallbackLng: "en", // use en if detected lng is not available
    keySeparator: false, // we do not use keys in form messages.welcome
    react: {
      useSuspense: false,
      defaultTransParent: 'div',
      wait: true
    },
    resources: {
      en: {
        translations: translationEng
      },
      hin: {
        translations: translationHin
      },
      hi: {
        translations: translationHin
      }
    },

    interpolation: {
      formatSeparator: ","
    },

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

  });

export default i18n;